import moment from 'moment'

export const formatDateToISO = date => {
  if (Array.isArray(date)) {
    if (!date[0] || date[0] === '') return ''
  }
  if (!date || date === '') return ''

  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

export const formatDateToString = date => {
  return new Date(date).toDateString()
}

export const isDateValid = date => {
  const unsafeDateCharacters = /[\\/*?=|$]/

  return !unsafeDateCharacters.test(date.toString())
}

export const parseDate = value => {
  if (!value) return null

  const validDate = isDateValid(value)
  if (!validDate) return null

  const parsedDateTime = Date.parse(value)
  if (!isNaN(parsedDateTime)) return new Date(moment(value).format('ll'))

  const parsedDate = Date.parse(value + ' 00:00')
  return !isNaN(parsedDate) ? new Date(moment(value).format('ll')) : null
}

export const formatDateToISOV2 = date => {
  if (!date || date === '' || (Array.isArray(date) && date.length === 0)) return ''

  if (Array.isArray(date) && date.length > 0) {
    return date.map(singleDateTimeItem => {
      return formatDateToISOV2(singleDateTimeItem)
    })
  }

  let d = new Date(moment(date).format('ll'))

  if (isNaN(d.getDate())) return ''

  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  let year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}
